import {
    Injectable
} from '@angular/core';

import {
    NgbModal
} from '@ng-bootstrap/ng-bootstrap';

import { OrderAuditReportComponent } from './order-audit-report.component';

/*
* Service to view the order audit-report modal.
*/
@Injectable()
export class ViewOrderAuditReportComponentService {

    constructor(
        private modalService: NgbModal
    ) {
        //
    }

    openComponent(orderKey: number) {
        const modalRef = this.modalService.open(OrderAuditReportComponent, { size: 'lg' });
        modalRef.componentInstance.orderKey = orderKey;
    }
}
